module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_30.13b46c61.jpg";